import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    TablePagination,
    Typography,
    useTheme,
    Card,
    CardContent,
    Menu,
    MenuItem,
    Divider,
    Modal
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {PathList} from "../../Common/Routes/Path";
import Loader from "../../Common/Loader";
import {apiList} from "../../Common/Api/ApiList";
import AxiosInstance from "../../Common/Api/ApiHelper";
import ErrorToaster from "../../Component/ErrorToaster";
import {DataGrid} from "@mui/x-data-grid";
import dotLogo from "../../Assets/image/dash/dots.svg";
import deleteicon from "../../Assets/image/FAQ/deleteicon.png";
import editIcon from "../../Assets/image/FAQ/Pen.png";
import Logo from "../../Assets/image/dash/logo.svg";
import {toast} from "react-toastify";
import FetchSignedUrl from "../../Component/URL_Generator";
import dummyimage from "../../Assets/image/user/9720009.jpg";
import searchicon from "../../Assets/image/dash/Minimalistic Magnifer.png";

const PAGE_SIZE_OPTIONS = [30];

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 330,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: 4,
};
const BadgesScreen = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchBadgesData = async (
        page = 0,
        pageSize = PAGE_SIZE_OPTIONS[0],
        search = ""
    ) => {
        try {
            let newPage = page * pageSize;
            const response = await AxiosInstance.get(
                `${apiList.BadgeList}?count=${newPage}&search=${search}`
            );
            const formatedData = response?.data?.r?.data?.map((x, i) => ({
                ...x,
                rowid: page * rowsPerPage + i + 1,
            }));

            if (formatedData?.length > 0) {
                setData(formatedData);
                setTotalData(response?.data?.r?.total_count ?? formatedData?.length);
            }else {
                if (newPage === 0) {
                    setData([]);
                }
                setTotalData(0);
            }
            setIsLoading(false);
        } catch (error) {
            ErrorToaster(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setPage(0);
            fetchBadgesData(0, rowsPerPage, searchTerm);
        }, 500);

        return () => clearTimeout(timer);
    }, [searchTerm]);



    const handlePageChange = (e, newPage) => {
        setPage(newPage);
        fetchBadgesData(newPage, rowsPerPage, searchTerm);
    };
    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 30);
        setRowsPerPage(newSize);
        setPage(0);
        fetchBadgesData(0, newSize, searchTerm);
    };

    // delete stuff
    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
        handleMenuClose();
    };
    const handleConfirmDelete = async () => {
        try {
            setOpenDeleteDialog(false);
            const response = await AxiosInstance.post(apiList?.DeleteBadge, {id: selectedRow});
            if (response.data.s === 1) {
                toast.success("Badge deleted successfully");
                await fetchBadgesData(page, rowsPerPage, searchTerm);
            } else {
                toast.error(response.data.m);
            }
        } catch (error) {
            console.error("Failed to delete badge:", error);
        }
    };
    // delete stuff

    const theme = useTheme();
    const columns = [
        {
            headerClassName: "super-app-theme--header",
            field: "rowid",
            headerName: "Sr.",
            flex: 0.3,
            minWidth: 50,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "badge_code",
            headerName: "Code",
            flex: 0.3,
            minWidth: 100,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "badge_name",
            headerName: "Name",
            flex: 1.5,
            minWidth: 150,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "user_type",
            headerName: "Type",
            flex: 1.5,
            minWidth: 100,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "badge_icon",
            headerName: "Icon",
            width: 90,
            headerAlign: "center",
            renderCell: (e) => {
                const path = e?.row?.badge_icon?.split(
                    "https://instatrainme-api.s3.amazonaws.com/"
                )[1];
                const i = FetchSignedUrl({path: path});
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {e?.row?.badge_icon ? (
                            <img
                                src={i}
                                alt=""
                                style={{
                                    height: "40px",
                                    width: "50px",
                                    borderRadius: "10px",
                                    border: "1px solid #E0E0E0",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                }}
                            />
                        ) : (
                            <img
                                src={dummyimage}
                                alt=""
                                style={{
                                    height: "40px",
                                    width: "50px",
                                    borderRadius: "10px",
                                    border: "1px solid #E0E0E0",
                                    cursor: "pointer",
                                }}
                            />
                        )}
                    </Box>
                );
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "description",
            headerName: "Description",
            flex: 1,
            minWidth: 150,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "criteria_name",
            headerName: "Criteria",
            flex: 1,
            minWidth: 180,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "sub_cat_name",
            headerName: "Category",
            flex: 1,
            minWidth: 180,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "xp_points",
            headerName: "XP Points",
            flex: 1,
            minWidth: 100,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "is_active",
            headerName: "Status",
            flex: 1,
            minWidth: 100,
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Typography
                        sx={{
                            fontWeight: 500,
                            marginTop: "12px",
                            color: params.value === 1 ? "green" : "red"
                        }}
                    >
                        {params.value === 1 ? "Active" : "Inactive"}
                    </Typography>
                )
            }
        },
        {
            headerClassName: "super-app-theme--header",
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 100,
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <>
                            <Button
                                id="basic-button"
                                onClick={(event) => handleMenuClick(event, params.row.id)}
                            >
                                <img src={dotLogo} alt="" srcSet=""/>
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleMenuClose}
                                PaperProps={{
                                    sx: {
                                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)", // lighter shadow
                                        borderRadius: "8px"
                                    }
                                }}
                            >
                                <MenuItem onClick={() => handleDeleteClick()}>
                                    <img src={deleteicon} style={{marginRight: "0.5rem"}} alt=""/>{" "}
                                    Delete
                                </MenuItem>
                                <Divider sx={{m: "0 7px"}}/>
                                <MenuItem
                                    onClick={() => navigate(`${PathList.EditBadge}/${selectedRow}`)}
                                    sx={{width: "160px"}}
                                >
                                    <img src={editIcon} style={{marginRight: "0.5rem"}} alt=""/> Edit
                                </MenuItem>
                                <Divider sx={{m: "0 7px"}}/>
                                <MenuItem onClick={() => navigate(`${PathList.ConvertChallenge}/${selectedRow}`)}>
                                    Covert to Challenge
                                </MenuItem>
                            </Menu>
                        </>
                    </Box>
                );
            },
        },
    ];

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pb: 0,
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{fontSize: "28px"}}
                    >
                        Badges
                    </Typography>
                    <Button
                        onClick={() =>
                            navigate(`${PathList.AddBadge}`)
                        }
                        sx={{
                            background:
                                "linear-gradient(181.45deg, #7AACFF -80.86%, rgba(60, 117, 213, 0.98) 98.77%)",
                            color: "white",
                            textTransform: "none",
                            "&:hover": {
                                background:
                                    "linear-gradient(181.45deg, #7AACFF -80.86%, rgba(60, 117, 213, 0.98) 98.77%)",
                            },
                        }}
                    >
                        + Add Badge
                    </Button>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        maxWidth: "300px",
                        height: "45px",
                        alignSelf: {xs: "start", lg: "end"},
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            height: "45px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                            border: "none",
                            outline: "none",
                            paddingLeft: "20px",
                        }}
                    />
                    <span
                        style={{
                            position: "absolute",
                            right: "15px",
                            top: "10px",
                        }}
                    >
                    <img src={searchicon} alt="Search"/>
                  </span>
                </Box>

                <Card style={{marginTop: "10px"}}>
                    <CardContent>
                        {isLoading ? (
                            <Loader/>
                        ) : (
                            <>
                                <Box sx={{width: "100%", overflowX: "auto"}}>
                                    <Box sx={{minWidth: 600}}>
                                        <DataGrid
                                            rows={data}
                                            columns={columns}
                                            disableColumnMenu
                                            disableColumnSorting
                                            hideFooter
                                            disableColumnFilter
                                            disableAutosize
                                            disableColumnResize
                                            getRowId={(row) => row.id}
                                            sx={{
                                                ".MuiDataGrid-cell": {textAlign: "center"},
                                                ".MuiDataGrid-columnHeaderTitle": {fontWeight: "600", color: "white"},
                                                "& .super-app-theme--header": {background: theme.palette.primary.Blend},
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <TablePagination
                                    component="div"
                                    count={totalData}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                    rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                                />
                            </>
                        )}
                    </CardContent>
                </Card>
            </Box>

            {openDeleteDialog && (
                <Modal
                    open={true}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100px",
                            }}
                        >
                            <img src={Logo} alt="Logo" srcSet=""/>
                        </Box>

                        <Typography
                            id="modal-modal-description"
                            sx={{mt: 1, textAlign: "center"}}
                        >
                            Are you sure ?
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                mt: 1,
                                fontSize: "18px",
                            }}
                        >
                            <Button
                                onClick={() => setOpenDeleteDialog(false)}
                                variant="outlined"
                                sx={{textTransform: "none"}}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleConfirmDelete}
                                variant="outlined"
                                sx={{
                                    textTransform: "none",
                                    background: theme.palette.primary.Blend,
                                    color: "#eee",
                                }}
                            >
                                Confirm
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )}
        </>
    )
}

export default BadgesScreen;